/* src/app/authorizenet-checkout/authorizenet-subscriptions-dialog/authorizenet-subscriptions-dialog.component.scss */
.subscriptions-dialog .subscriptions-section-title {
  margin: 0 0 0.25rem;
  font-size: 1.1rem;
}
.subscriptions-dialog .subscriptions-label {
  display: block;
  font-weight: 600;
  margin-bottom: 0.35rem;
}
.subscriptions-dialog .subscriptions-id-hints {
  line-height: 1.8;
}
.subscriptions-dialog .subscriptions-id-button {
  margin: 0 0.5rem 0.35rem 0;
  min-width: auto;
}
.subscriptions-dialog .subscriptions-summary {
  font-size: 0.9rem;
}
.subscriptions-dialog .subscriptions-results .subscriptions-json {
  margin: 0;
  padding: 0.75rem;
  max-height: 22rem;
  overflow: auto;
  border: 1px solid var(--surface-border, #dee2e6);
  border-radius: var(--border-radius, 6px);
  background: var(--surface-ground, #f8f9fa);
  font-size: 0.8rem;
  white-space: pre-wrap;
  word-break: break-word;
}
.subscriptions-dialog .subscriptions-results .subscriptions-placeholder {
  margin: 0;
  padding: 0.75rem;
  border: 1px dashed var(--surface-border, #dee2e6);
  border-radius: var(--border-radius, 6px);
}
/*# sourceMappingURL=authorizenet-subscriptions-dialog.component.css.map */
